var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVk = function SvgVk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4494 5.9286C23.6163 5.39338 23.4494 5 22.6553 5H20.0297C19.362 5 19.0544 5.33979 18.8875 5.71459C18.8875 5.71459 17.5522 8.84595 15.6607 10.88C15.0487 11.4688 14.7706 11.6559 14.4367 11.6559C14.2698 11.6559 14.0283 11.4688 14.0283 10.9336V5.9286C14.0283 5.2862 13.8345 5 13.2781 5H9.15214C8.73504 5 8.48411 5.29811 8.48411 5.58069C8.48411 6.18971 9.4297 6.33011 9.52722 8.04295V11.7633C9.52722 12.5789 9.37419 12.7269 9.04036 12.7269C8.15028 12.7269 5.98527 9.58129 4.70097 5.9822C4.44929 5.28259 4.19685 5 3.52582 5H0.90021C0.150035 5 0 5.33979 0 5.71459C0 6.3837 0.89027 9.70256 4.14472 14.0919C6.3146 17.0891 9.37119 18.7143 12.1528 18.7143C13.822 18.7143 14.0283 18.3534 14.0283 17.7317V15.4662C14.0283 14.7444 14.1864 14.6004 14.7147 14.6004C15.1044 14.6004 15.7719 14.7877 17.3298 16.2329C19.11 17.9456 19.4033 18.7143 20.4048 18.7143H23.0304C23.7806 18.7143 24.1556 18.3534 23.9392 17.6411C23.7025 16.9312 22.8526 15.9016 21.7247 14.6807C21.1127 13.9847 20.1947 13.2352 19.9168 12.8606C19.5272 12.3788 19.6385 12.1648 19.9168 11.7368C19.9168 11.7368 23.1155 7.4009 23.4494 5.92878V5.9286Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vk.65fe2677.svg";
export { ForwardRef as ReactComponent };